import { createDetailDialog } from 'dialogs/common'
import { dialogSizes } from 'dialogs'
import Form from 'pages/wineStyles/form'
import { api, actionCreators } from 'store/modules/wineStyles'

const metadata = {
  icon: 'align-justyfy',
  page: 'wineStyles',
  dialogSize: dialogSizes.MD
}

export default createDetailDialog({ metadata, api, actionCreators, Form })
